export default "__VITE_ASSET__Ds_93d6a__"